import HeartIcon from 'components/shared/heart-icon';
import { useWishlist, useLocalWishlist } from 'hooks';
import { useGlobalModules } from 'contexts';
import { getShopifyGid } from 'lib/shopify/shopifyGid';
import classNames from 'classnames';
import trackWishlist from 'lib/utils/trackWishlist';
import styles from './wishlistButton.module.scss';

const WishlistButton = ({ productData, className, list, index }) => {
  const { addToWishlist, removeFromWishlist } = useWishlist();
  const { localWishlist } = useLocalWishlist();
  const globalModules = useGlobalModules();
  const { shopifyData } = productData || {};

  if (!localWishlist) {
    return null;
  }

  const getGIDs = () => {
    if (!shopifyData) return [];
    if (Array.isArray(shopifyData)) {
      return shopifyData.map(({ productId }) => getShopifyGid('Product', productId));
    }
    return [
      getShopifyGid('Product', shopifyData?.productId || shopifyData?.variants?.[0]?.product_id),
    ].filter(Boolean);
  };

  const GIDs = getGIDs();

  const isInWishlist = GIDs.length && GIDs.every(id => localWishlist.includes(id));

  const handleClick = async event => {
    event.stopPropagation();
    event.preventDefault();

    if (isInWishlist) {
      await removeFromWishlist(GIDs);
    } else {
      await addToWishlist(GIDs);
    }

    trackWishlist(
      productData,
      shopifyData,
      isInWishlist ? 'remove_from_wishlist' : 'add_to_wishlist',
      list,
      index
    );
  };

  if (!GIDs?.length) {
    return null;
  }

  const wishlistLabel =
    globalModules?.translations?.accessibility?.addToWishlist || 'Add to wishlist';

  return (
    <button
      type="button"
      aria-label={productData?.title ? `${wishlistLabel}: ${productData.title}` : wishlistLabel}
      aria-pressed={Boolean(isInWishlist)}
      className={classNames(styles.container, className)}
      onClick={handleClick}
    >
      <HeartIcon type={isInWishlist ? 'red' : ''} />
    </button>
  );
};

export default WishlistButton;
